// Excel експортът на „Отстъпки и надбавки".
//
// Редовете идват ФИЛТРИРАНИ и ПОДРЕДЕНИ от таблицата (`onFilteredRowsChange`),
// не суровият отговор: файлът повтаря екрана, включително филтрите в колоните.
// БЕЗ собствен времеви печат — `exportToExcel` вече лепи `_${stamp}`.
//
// Датата се форматира РЪЧНО: `toLocaleDateString("bg-BG")" добавя „ г." и
// клетката се разчита по-трудно.

import dayjs from "dayjs";

import { exportToExcel } from "../../../../utils/excelExport";
import type { NamedDiscountRow } from "./discountsMath";

type Context = {
  t: (key: string) => string;
};

/** Числата излизат като ЧИСЛА, не форматирани низове. */
const round2 = (value: number) => Number(value.toFixed(2));

export const exportDiscounts = (
  rows: readonly NamedDiscountRow[],
  { t }: Context,
) => {
  exportToExcel<NamedDiscountRow>({
    filename: t("reportsPage.clientsTitle"),
    sheetName: t("reportsPage.clientsReport"),
    columns: [
      {
        header: t("reportsPage.discountsBillId"),
        value: (row) => row.billLabel,
        width: 12,
      },
      {
        header: t("reportsPage.date"),
        value: (row) =>
          row.closed_at ? dayjs(row.closed_at).format("DD.MM.YYYY HH:mm") : "",
        width: 18,
      },
      {
        header: t("reportsPage.waiter"),
        value: (row) => row.waiterLabel,
        width: 22,
      },
      {
        header: t("reportsPage.discountsClient"),
        value: (row) => row.clientLabel,
        width: 22,
      },
      {
        header: t("reportsPage.guestsCount"),
        value: (row) => row.guests ?? "",
        width: 12,
      },
      {
        header: t("reportsPage.discountsKind"),
        value: (row) => row.kindLabel,
        width: 14,
      },
      {
        header: t("reportsPage.discountsType"),
        value: (row) => row.typeLabel,
        width: 18,
      },
      {
        header: t("reportsPage.discountsPercent"),
        value: (row) => round2(row.percentAbs),
        width: 12,
      },
      {
        header: t("reportsPage.discountsBefore"),
        value: (row) => round2(row.amountBefore),
        width: 14,
      },
      // Знаковото отражение върху сметката: отрицателно = отстъпка,
      // положително = надбавка. Така колоната се сумира в Excel без ръчно
      // разделяне на двата вида.
      {
        header: t("reportsPage.discountsGiven"),
        value: (row) => round2(row.adjustment),
        width: 14,
      },
      {
        header: t("reportsPage.discountsPaid"),
        value: (row) => round2(row.paid),
        width: 14,
      },
    ],
    rows: [...rows],
  });
};
